.modal-container {
    width: min(960px, calc(100vw - 32px));
    max-height: calc(100vh - 32px);
}

.modal-chrome {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border-radius: 20px;
    background: #101522;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
}

.header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.title {
    font-family: doyle, 'IBM Plex Sans';
    color: #fff;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.5;
}

.close-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    padding: 0;
    border: 0;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    cursor: pointer;
    transition:
        background-color 160ms ease,
        transform 160ms ease;
}

.close-button:hover {
    background: rgba(255, 255, 255, 0.18);
}

.close-button:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.85);
    outline-offset: 2px;
}

.close-button:active {
    transform: scale(0.98);
}

.video-frame {
    position: relative;
    overflow: hidden;
    border-radius: 16px;
    background: #000;
    aspect-ratio: 16 / 9;
    min-height: 320px;
}

.video {
    display: block;
    width: 100%;
    height: 100%;
    background: #000;
}

.loading-state {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

@media (max-width: 720px) {
    .modal-container {
        width: calc(100vw - 16px);
        max-height: calc(100vh - 16px);
    }

    .modal-chrome {
        gap: 12px;
        padding: 16px;
        border-radius: 16px;
    }

    .title {
        font-size: 20px;
    }

    .video-frame {
        min-height: 220px;
    }
}
